<script setup lang="ts">
import { use_auth } from "@/auth/useAuth";
import TopBar from "@/components/TopBar.vue";

const authStore = use_auth();
</script>

<template>
  <TopBar v-if="authStore.isLoggedIn" />
  <main
    class="bg-base-300 mx-auto flex h-[calc(100vh-65px)] flex-col overflow-y-auto px-8 py-4"
  >
    <slot>
      <RouterView />
    </slot>
  </main>
</template>
